import { FC, useEffect } from "react";
import { useOrganization } from "hooks/useOrganization";
import StepInfo from "pages/StepPages/components/StepInfo";
import { useParams } from "react-router-dom";
import AddingEmployees from "./AddingEmployees";
import AlreadyAdded from "./AlreadyAdded";
import { useAppDispatch, useAppSelector } from "toolkit/hooks";
import { clearEmployees } from "toolkit/steps/stepOne/stepOne.slice";
import { getCommission, getRoles } from "toolkit/steps/stepOne/stepOne.thunks";
import styles from "./NewCommission.module.sass";

const NewCommission: FC = () => {
	const dispatch = useAppDispatch();

	const { organizationId, commissionId } = useParams();

	const selectedOrganization = useOrganization(Number(organizationId));

	const roles = useAppSelector((state) => state.stepOne.roles);

	useEffect(() => {
		if (commissionId) {
			dispatch(getCommission(+commissionId));
		} else {
			dispatch(clearEmployees());
		}
		//eslint-disable-next-line
	}, []);

	useEffect(() => {
		if (!roles.length) {
			dispatch(getRoles());
		}

		return () => {
			dispatch(clearEmployees());
		};
		//eslint-disable-next-line
	}, []);

	return (
		<div className="step-wrapper">
			<div className="step-header">
				<StepInfo
					stepTitle="1.Создание комиссии по категорированию ОКИИ"
					info="Создание комиссии по категорированию объектов КИИ"
					companyName={selectedOrganization?.fullName}
				/>
			</div>
			<div className={styles.main}>
				<AddingEmployees />
				<AlreadyAdded />
			</div>
		</div>
	);
};

export default NewCommission;
